import type { PlacementInfoForm } from "@design-lab/shared/types";
import type { Artwork } from "@design-lab/shared/types/artwork";

/**
 * Selects the effective image URL for dimension calculations based on
 * the user's enhancement settings. Mirrors the selection logic in
 * useArtworkEnhancedImages so that dimensions match the displayed image.
 */
export function getEffectiveImageUrl(
  artwork: Artwork | undefined,
  info: PlacementInfoForm | undefined
): string | undefined {
  if (!artwork) return undefined;

  if (artwork.manualEditUrl) return artwork.manualEditUrl;

  const enhancementTier = info?.enhancementTier;
  // Default true: matches the display layer (useArtworkEnhancedImages) which shows
  // the bg-removed image by default. Other call sites use ?? false for different contexts.
  const removeBackground = info?.removeBackground ?? true;
  const canRemoveBg = artwork.canRemoveBg ?? true;

  if (enhancementTier === "print_original" || enhancementTier === "custom") {
    return artwork.originalImageUrl;
  }

  if (removeBackground && canRemoveBg) {
    const noBgUrl = artwork.noBgUrl || artwork.noBgNoTrimUrl;
    if (noBgUrl) return noBgUrl;
  }

  return artwork.withBgUrl || artwork.originalImageUrl;
}
